$(document).ready(function () {
    var shoppinglistBtn = $('.products__item-wishlist, .detail__wishlist')
    shoppinglistBtn.click(function () {
        var self = $(this)
        if (!self.hasClass('disabled')) {
            self.addClass('disabled')

            $.ajax({
                type: 'POST',
                url: LANGROOT + '/club/ajax/shopping-list/',
                data: {
                    productId: self.data('id'),
                },
                dataType: 'json',
                beforeSend: function () {},
                success: function (response) {
                    if (response.status == 'ok') {
                        report(response.message, 'ok')
                        self.html(response.ico)
                    } else {
                        report(response.message, response.status)
                    }
                },
                error: function () {
                    report(__('Chyba zo strany servera'), 'error')
                },
                complete: function () {
                    self.removeClass('disabled')
                    return true
                },
            })
        }
    })
})
